import { http } from '../lib/api/http';

const ENDPOINT = '/cancellation-reasons';

const AVAILABLE_REASONS = ['cost', 'usage', 'alternative', 'support', 'other'];

const coerceString = value => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value.trim();
  try {
    return String(value || '').trim();
  } catch {
    return '';
  }
};

const normalizeReason = reason => {
  const candidate = coerceString(reason).toLowerCase();
  return AVAILABLE_REASONS.includes(candidate) ? candidate : 'other';
};

const buildPayload = payload => {
  const contextValue =
    payload?.context && typeof payload.context === 'object' ? payload.context : null;

  const body = {
    reason: normalizeReason(payload?.reason),
  };

  const notes = coerceString(payload?.notes);
  if (notes) {
    body.notes = notes;
  }

  const subscriptionId = coerceString(payload?.subscriptionId);
  if (subscriptionId) {
    body.subscription_id = subscriptionId;
  }

  if (contextValue) {
    body.context = contextValue;
  }

  return body;
};

const handleRequestError = error => {
  if (error?.status === 404) {
    throw new Error(
      'No encontramos el endpoint "/cancellation-reasons". Asegúrate de que el backend esté actualizado.'
    );
  }
  throw error;
};

export async function createCancellationReason(payload = {}) {
  const body = buildPayload(payload);

  if (!body.reason) {
    throw new Error('Selecciona un motivo para continuar.');
  }

  try {
    const { data } = await http.post(ENDPOINT, body);
    return data;
  } catch (error) {
    handleRequestError(error);
    return null;
  }
}
